export class DueDiligenceClaims
{
    static CanViewDueDiligenceRunsTab: string = "CanViewDueDiligenceRunsTab";
    static CanViewDueDiligenceHistoryTrail: string = "CanViewDueDiligenceHistoryTrail";
    static AssignDueDiligenceToRightShip: string = "AssignDueDiligenceToRightShip";
    static CanViewDueDiligenceMessageCenterTab: string = "CanViewDueDiligenceMessageCenterTab";
    static CanViewDueDiligenceDocumentsTab: string = "CanViewDueDiligenceDocumentsTab";
    static ShowBlackSeaTrade: string = "ShowBlackSeaTrade";
    static CanManageCollaborators: string = "CanManageCollaborators";
    static CanRequestDueDiligence: string = "CanRequestDueDiligence";
    static ShowReRunInDueDiligence: string = "ShowReRunInDueDiligence";
    static ShowDueDiligenceProcessSectionInDueDiligenceConfiguration: string = "ShowDueDiligenceProcessSectionInDueDiligenceConfiguration";
    static CanViewDueDiligenceEmailHistory: string = "CanViewDueDiligenceEmailHistory";
    static ShowDueDiligenceWidget: string = "ShowDueDiligenceWidget";
    static ShowAiSummaryInDueDiligence: string = "ShowAiSummaryInDueDiligence";
    static CanAccessNotesInDueDiligence: string = "CanAccessNotesInDueDiligence";
    static CanAddAndDeleteNotesInDueDiligence: string = "CanAddAndDeleteNotesInDueDiligence";
    static ShowDueDiligenceOutcomeRequiredBy: string = "ShowDueDiligenceOutcomeRequiredBy";
    static DueDiligenceOutcomeRequiredByIsMandatory: string = "DueDiligenceOutcomeRequiredByIsMandatory";
    static DueDiligenceHideReviewButtonWhenUnacceptable: string = "HideReviewButtonWhenUnacceptable";
    static CanRequestSeniorApproval: string = "CanRequestSeniorApproval";
    static CanReviewDueDiligence: string = "CanReviewDueDiligence";
    static CanMarkConversationAsAllReadOrCompleted: string = "CanMarkConversationAsAllReadOrCompleted";
}